import Icon from "@shared/components/ui-kit/icons/Icon.web";

import Flex from "@ui-kit/layout/Flex/Flex.web";

export default function FiveStarRating({ rating }: { rating: number }) {
  return (
    <Flex
      data-testid="five-star-rating"
      direction="row"
      gap="2xs"
      alignItems="center"
    >
      {[...Array(5)].map((_, index) =>
        index + 1 <= rating ? (
          <Icon.BasicStar
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            data-testid="filled-star"
            color="yellow.400"
            boxSize="element.lg"
          />
        ) : (
          <Icon.BasicStar
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            data-testid="empty-star"
            color="gray.400"
            boxSize="element.lg"
          />
        )
      )}
    </Flex>
  );
}
